import {calculatePriceFromInstalment} from "../../credit_calculator/utils/calculate_price_from_instalment";
import {getOfferListSortName} from "../../offer/helpers/get_offer_list_sort_name";
import {OfferDisplayType} from "../../offer/helpers/OfferDisplayType";
import {ISelectedRegion} from "../../offer/list/actions/offer_list_selected_data_actions";
import {SearchSortString} from "../../offer/list/constants/SearchSort";
import {OfferType} from "../../offer/types/OfferType";
import {QuarterType} from "../../property/components/PropertyDetailGeneratedDescriptionFlat";
import {FloorChoice} from "../../real_estate/types/FloorChoice";
import {Country} from "../../region/types/Country";
import {SearchTab} from "../../search/actions/fetch_search_all_action";
import {Floor} from "../types/Floor";
import {KitchenType} from "../types/KitchenType";
import {AdditionalAreaType, FormAdditionalAreaType, FormRoomType, RoomType} from "../types/RoomType";

interface ILowerUpperInput {
    lower: string | number;
    upper: string | number;
}
export interface IFetchParams {
    country: Country;
    area_0?: string | number;
    area_1?: string | number;
    rooms_0?: string | number;
    rooms_1?: string | number;
    price_0?: string | number;
    price_1?: string | number;
    room_type?: RoomType[];
    additional_areas?: AdditionalAreaType[];
    distance?: number;
    quarters?: QuarterType[];
    construction_end_date?: number[];
    floor_choices?: number[];
    region?: number[];
    page?: number;
    display_type: OfferDisplayType;
    exclude_compass_offers?: string;
    sort: string;
    limited_presentation: string;
    show_on_listing: string;
    offer_type: OfferType;
}

const getFloorChoices = (floorInputValue: Floor[]) => {
    const floors: number[] = [];
    if (floorInputValue.includes(Floor.GROUND)) {
        floors.push(FloorChoice.GROUND);
    }

    if (floorInputValue.includes(Floor.LOWER)) {
        floors.push(FloorChoice.LOW_LEVELS);
    }

    if (floorInputValue.includes(Floor.UPPER)) {
        floors.push(FloorChoice.HIGH_LEVELS);
    }

    if (floorInputValue.includes(Floor.TOP)) {
        floors.push(FloorChoice.LAST_LEVEL);
    }

    return floors;
};

interface IInputParams {
    rooms_area_type_selected?: (FormRoomType | FormAdditionalAreaType)[];
    distance: number;
    area: ILowerUpperInput;
    rooms: ILowerUpperInput;
    price: ILowerUpperInput;
    world_directions?: QuarterType[];
    construction_end_date: null | number[];
    floors: Floor[];
    page?: number;
    search?: {
        label: string;
        regions: ISelectedRegion[];
        tabType: SearchTab;
    };
    kitchen_type: KitchenType[];
    instalment?: number;
}

const getMaxPrice = (price: number | string) => {
    if ((typeof price === "string" ? parseInt(price) : price) > 2147483647) {
        return 2147483647;
    }
    return price;
};
export const getParams = (formValues: IInputParams, sortValue: number): IFetchParams => {
    const regions = (formValues.search?.regions?.map((region: {id: number}) => region.id) || []) as number[];
    const {distance} = formValues;
    const additional_areas = formValues.rooms_area_type_selected
        ?.filter((value: string) => value?.includes("as_"))
        .map((value: string) => parseInt(value.split("as_")[1])) as AdditionalAreaType[];
    const worldDirectionsFilterSize = formValues?.world_directions?.length;

    const getAreaNumber = (area: string | number) => {
        if (typeof area === "number") {
            return area;
        }

        const areaNumber = parseInt(area);
        if (!isNaN(areaNumber)) {
            return areaNumber;
        }

        return 0;
    };
    const area_0 = getAreaNumber(formValues.area.lower);
    const area_1 = getAreaNumber(formValues.area.upper);

    return {
        country: Country.POLAND,
        display_type: OfferDisplayType.FOR_SALE,
        exclude_compass_offers: "True",
        limited_presentation: "False",
        show_on_listing: "True",
        offer_type: OfferType.FLAT,
        region: regions,
        ...(distance && {distance}),
        ...(area_0 && (area_0 < area_1 || !area_1) && {area_0}),
        ...(area_1 && (area_0 < area_1 || !area_0) && {area_1}),
        ...(formValues.rooms?.lower && {rooms_0: formValues.rooms.lower}),
        ...(formValues.rooms?.upper && {rooms_1: formValues.rooms.upper}),
        ...(formValues.price?.lower && !formValues.instalment && {price_0: getMaxPrice(formValues.price.lower)}),
        ...(formValues.price?.upper && !formValues.instalment && {price_1: getMaxPrice(formValues.price.upper)}),
        ...(formValues.instalment && {price_1: calculatePriceFromInstalment(formValues.instalment).toString()}),
        // commented until data about room types is available
        // ...(!!room_type.length && {room_type}),
        ...(!!additional_areas.length && {additional_areas}),
        ...(worldDirectionsFilterSize && worldDirectionsFilterSize < 4 && {quarters: formValues.world_directions}),
        ...(!!formValues?.construction_end_date?.length && {construction_end_date: formValues.construction_end_date}),
        floor_choices: getFloorChoices(formValues.floors),
        ...(formValues.page && {page: formValues.page}),
        ...(formValues.rooms_area_type_selected?.includes(FormRoomType.KITCHEN) && {kitchen_type: 2}),
        sort: getOfferListSortName(sortValue.toString() as SearchSortString),
        ...(!!formValues.kitchen_type.length && {kitchen_type: formValues.kitchen_type})
    };
};
import {calculatePriceFromInstalment} from "../../credit_calculator/utils/calculate_price_from_instalment";
import {getOfferListSortName} from "../../offer/helpers/get_offer_list_sort_name";
import {OfferDisplayType} from "../../offer/helpers/OfferDisplayType";
import {ISelectedRegion} from "../../offer/list/actions/offer_list_selected_data_actions";
import {SearchSortString} from "../../offer/list/constants/SearchSort";
import {OfferType} from "../../offer/types/OfferType";
import {QuarterType} from "../../property/components/PropertyDetailGeneratedDescriptionFlat";
import {FloorChoice} from "../../real_estate/types/FloorChoice";
import {Country} from "../../region/types/Country";
import {SearchTab} from "../../search/actions/fetch_search_all_action";
import {Floor} from "../types/Floor";
import {KitchenType} from "../types/KitchenType";
import {AdditionalAreaType, FormAdditionalAreaType, FormRoomType, RoomType} from "../types/RoomType";

interface ILowerUpperInput {
    lower: string | number;
    upper: string | number;
}
export interface IFetchParams {
    country: Country;
    area_0?: string | number;
    area_1?: string | number;
    rooms_0?: string | number;
    rooms_1?: string | number;
    price_0?: string | number;
    price_1?: string | number;
    room_type?: RoomType[];
    additional_areas?: AdditionalAreaType[];
    distance?: number;
    quarters?: QuarterType[];
    construction_end_date?: number[];
    floor_choices?: number[];
    region?: number[];
    page?: number;
    display_type: OfferDisplayType;
    exclude_compass_offers?: string;
    sort: string;
    limited_presentation: string;
    show_on_listing: string;
    offer_type: OfferType;
}

const getFloorChoices = (floorInputValue: Floor[]) => {
    const floors: number[] = [];
    if (floorInputValue.includes(Floor.GROUND)) {
        floors.push(FloorChoice.GROUND);
    }

    if (floorInputValue.includes(Floor.LOWER)) {
        floors.push(FloorChoice.LOW_LEVELS);
    }

    if (floorInputValue.includes(Floor.UPPER)) {
        floors.push(FloorChoice.HIGH_LEVELS);
    }

    if (floorInputValue.includes(Floor.TOP)) {
        floors.push(FloorChoice.LAST_LEVEL);
    }

    return floors;
};

interface IInputParams {
    rooms_area_type_selected?: (FormRoomType | FormAdditionalAreaType)[];
    distance: number;
    area: ILowerUpperInput;
    rooms: ILowerUpperInput;
    price: ILowerUpperInput;
    world_directions?: QuarterType[];
    construction_end_date: null | number[];
    floors: Floor[];
    page?: number;
    search?: {
        label: string;
        regions: ISelectedRegion[];
        tabType: SearchTab;
    };
    kitchen_type: KitchenType[];
    instalment?: number;
}

const getMaxPrice = (price: number | string) => {
    if ((typeof price === "string" ? parseInt(price) : price) > 2147483647) {
        return 2147483647;
    }
    return price;
};
export const getParams = (formValues: IInputParams, sortValue: number): IFetchParams => {
    const regions = (formValues.search?.regions?.map((region: {id: number}) => region.id) || []) as number[];
    const {distance} = formValues;
    const additional_areas = formValues.rooms_area_type_selected
        ?.filter((value: string) => value?.includes("as_"))
        .map((value: string) => parseInt(value.split("as_")[1])) as AdditionalAreaType[];
    const worldDirectionsFilterSize = formValues?.world_directions?.length;

    const getAreaNumber = (area: string | number) => {
        if (typeof area === "number") {
            return area;
        }

        const areaNumber = parseInt(area);
        if (!isNaN(areaNumber)) {
            return areaNumber;
        }

        return 0;
    };
    const area_0 = getAreaNumber(formValues.area.lower);
    const area_1 = getAreaNumber(formValues.area.upper);

    return {
        country: Country.POLAND,
        display_type: OfferDisplayType.FOR_SALE,
        exclude_compass_offers: "True",
        limited_presentation: "False",
        show_on_listing: "True",
        offer_type: OfferType.FLAT,
        region: regions,
        ...(distance && {distance}),
        ...(area_0 && (area_0 < area_1 || !area_1) && {area_0}),
        ...(area_1 && (area_0 < area_1 || !area_0) && {area_1}),
        ...(formValues.rooms?.lower && {rooms_0: formValues.rooms.lower}),
        ...(formValues.rooms?.upper && {rooms_1: formValues.rooms.upper}),
        ...(formValues.price?.lower && !formValues.instalment && {price_0: getMaxPrice(formValues.price.lower)}),
        ...(formValues.price?.upper && !formValues.instalment && {price_1: getMaxPrice(formValues.price.upper)}),
        ...(formValues.instalment && {price_1: calculatePriceFromInstalment(formValues.instalment).toString()}),
        // commented until data about room types is available
        // ...(!!room_type.length && {room_type}),
        ...(!!additional_areas.length && {additional_areas}),
        ...(worldDirectionsFilterSize && worldDirectionsFilterSize < 4 && {quarters: formValues.world_directions}),
        ...(!!formValues?.construction_end_date?.length && {construction_end_date: formValues.construction_end_date}),
        floor_choices: getFloorChoices(formValues.floors),
        ...(formValues.page && {page: formValues.page}),
        ...(formValues.rooms_area_type_selected?.includes(FormRoomType.KITCHEN) && {kitchen_type: 2}),
        sort: getOfferListSortName(sortValue.toString() as SearchSortString),
        ...(!!formValues.kitchen_type.length && {kitchen_type: formValues.kitchen_type})
    };
};
